import styled from 'styled-components';

export const ReportEditDetailsForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;
